import cx from 'clsx';
import React, { type ReactElement } from 'react';
import type { AnySchema } from 'valibot';

import ProgressBar from '@components/common/ProgressBar/ProgressBar';

import style from './style.module.scss';

interface IStep {
  step: number;
  previousStepIndex: string | number;
  nextStepIndex: string | number;
}

interface IProps {
  stepName: string;
  currentStep: number;
  steps: IStep[];
  variant?: 'withoutBorder';
}

const ModalSteps: React.FC<IProps> = ({ stepName, currentStep, steps, variant }) => {
  return (
    <div
      className={cx(style.modalSteps, {
        [style.modalStepsWithoutBorder]: variant === 'withoutBorder',
      })}
    >
      <span className={style.modalStepsText}>{stepName}</span>
      <ProgressBar currentStep={currentStep} steps={steps} />
    </div>
  );
};

export default ModalSteps;
